import React from 'react';
import Last5 from './../../../../components/last_5/Last5';
import { env_url } from '../../../../utils/js/endpoints';

export function generateTeamLogoAndNameComponent(teamName, imageUrl, wrapperClass, isMobileApp) {
	const defaultLogoUrl = `${env_url}/bracket-images/fifa-default-logo${isMobileApp ? '-dark' : ''}.svg`;

	return (
		<div className={wrapperClass}>
			<img
				src={imageUrl}
				alt={`${teamName} logo`}
				onError={e => {
					e.target.src = defaultLogoUrl;
				}}
			/>
			{teamName}
		</div>
	);
}

export function generateLast5Component(data, allTeams, sport) {
	return <Last5 data={data} allTeams={allTeams} containerClass='last5' sport={sport} draw={sport === 'soccer'} />;
}
